import {
  Injectable,
  Type,
  inject,
  signal
} from '@angular/core';

import { isArray } from '@core/helpers';
import { ChatState } from '@app/modules/chat';

const PATH_TO_GAME_MODULE: Record<string, string> = {
  '/crash': 'crash',
  '/wheel': 'wheel',
  '/jackpot': 'jackpot',
  '/double': 'double',
  '/defuse': 'defuse',
  '/mines': 'mines'
};

type StickyBetComponents = {
  toggler: Type<any>;
  content: Type<any>;
  userBets?: Type<any>;
  isPayment?: boolean;
};

@Injectable({
  providedIn: 'root'
})
export class WrapperState {
  private readonly chatState = inject(ChatState);

  public readonly isStretchFooter = signal<boolean>(false);
  public readonly isShopOpen = signal<boolean>(false);
  public readonly gameModule = signal<string|null>(null);
  public readonly classList = signal<string[]>([]);
  public readonly stickyBetComponents = signal<StickyBetComponents|undefined>(undefined);

  constructor() {
    const isChatOpen = this.chatState.isOpen();

    if(isChatOpen) {
      this.classList.set([...this.classList(), 'chat_open']);
    }
  }

  setShopOpen(value: boolean): void {
    this.isShopOpen.set(value);
  }

  setPath(path: string): void {
    const url = new URL(path, 'http://localhost');
    const { pathname } = url;

    const gameModule = PATH_TO_GAME_MODULE[pathname] || null;

    this.gameModule.set(gameModule);

    const hasGameWrapperClass = this.classList().includes('wrapper_game');

    if(hasGameWrapperClass && null === gameModule) {
      this.classList.update(classList => classList.filter((className) => 'wrapper_game' !== className));
    } else if(!hasGameWrapperClass && null !== gameModule) {
      this.classList.set([...this.classList(), 'wrapper_game']);
    }

    this.isStretchFooter.set(
      pathname.startsWith('/season-pass')
    );
  }

  setStickyBetComponents(components: StickyBetComponents|undefined): void {
    this.stickyBetComponents.set(components);
  }

  addClass(className: string|string[]): void {
    const classList = this.classList();
    const newClassNames = !isArray(className) ? [ className ] : className;

    newClassNames.forEach((newClassName: string) => {
      if(classList.includes(newClassName)) {
        return;
      }

      classList.push(newClassName);
    });

    this.classList.set(classList);
  }

  removeClass(className: string|string[]): void {
    const removeClassNames = !isArray(className) ? [ className ] : className;

    this.classList.update(classList => classList.filter(item => !removeClassNames.includes(item)));
  }
}